import { AxiosResponse } from 'axios'

const securityWorker = async (_securityData) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

  return {
    headers: {
      'X-CSRF-Token': token,
    },
  }
}

export function createClient<T>(klass: new (params: unknown) => T) {
  return new klass({ secure: true, securityWorker })
}

// apipie-rails で included の型表現が難しいため型定義でカバーする
// AxiosResponse から中身を取り出し、 included と一緒に AxiosResponse に詰め直す
export type JSONAPIResponse<T extends (...args: any) => any> = AxiosResponse<{
  data: Awaited<ReturnType<T>> extends AxiosResponse<infer X> ? X : never
  included: {
    id: string
    type: string
    attributes: Record<string, any>
    relationships: Record<string, { data: { id: string; type: string } }>
  }[]
}>
